var map = {
	"./gamifinna-fly.png": "d8d6",
	"./gamifinna-like.png": "83ea",
	"./gamifinna-profile.png": "b665",
	"./gamifinna-yoga.png": "a74d",
	"./gamifinnator-fly.png": "5001",
	"./gamifinnator-thinker.png": "cc35",
	"./gamifinnator-yes.png": "2ed5",
	"./gamifinnator-yoga.png": "2113"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9210";